import DataManager from '../data/DataManager'

/**
 * クエリーパラメーター取得メソッド
 */
const getParam = (key, url) => 
{
  if (!url) url = window.location.href;
  key = key.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * ディレクトリ取得
 */
const getDirectory = () =>
{
  const pathname = location.pathname
  return pathname.substring(0, pathname.lastIndexOf('/')) + '/'
}

/**
 * 絶対パス取得
 */
const getAbsolutePath = (path, root = true) =>
{
  //ルートディレクトリ参照の場合
  if(root)
  {
    path = '/' + DataManager.getData('asset_path') + path.slice(1)
  }

  return path
}

/**
 * 絶対パス取得(CDN)
 */
const getCDNPath = (path, root = true) =>
{
  //相対パスの場合は絶対パスに変更
  if(path.indexOf('./') == 0)
  {
    path = getDirectory() + path.split('./')[1];
  } 

  //ルートディレクトリ参照の場合
  if(root)
  {
    path = DataManager.getData('cdn_asset_path') + DataManager.getData('asset_path') + path.slice(1)
  }
  //相対パスの場合
  else
  {
    path = DataManager.getData('cdn_asset_path') + path.slice(1)
  }
  return path
}

const LocationUtil = {
  getParam:getParam,
  getDirectory:getDirectory,
  getAbsolutePath:getAbsolutePath,
  getCDNPath:getCDNPath
}

export default LocationUtil